export default {
  "title": "Politique des cookies",
  "lastUpdated": "Dernière mise à jour : 26 mai 2026",
  "back": "← Retour à l'accueil",
  "intro": [
    {
      "type": "p",
      "text": "La présente politique des cookies explique comment Demakstore Gıda İhracat San. ve Tic. Ltd. Şti., exploitant la marque DeMaxtore (« DeMaxtore », « nous », « notre »), utilise les cookies et technologies similaires sur www.demaxtore.com."
    },
    {
      "type": "p",
      "text": "En utilisant notre site, vous pouvez accepter, refuser ou gérer certains cookies selon leur finalité. Certains cookies sont nécessaires au bon fonctionnement du site ; d’autres servent à améliorer l’expérience, analyser les performances et soutenir les activités marketing."
    }
  ],
  "sections": [
    {
      "title": "1. Gérer vos préférences en matière de cookies",
      "blocks": [
        {
          "type": "p",
          "text": "Certaines fonctions de notre site peuvent reposer sur des services fournis par des tiers. Si vous donnez votre consentement, ces tiers peuvent placer des cookies ou technologies similaires sur votre appareil pour vous permettre de consulter, interagir avec ou partager du contenu hébergé par ces tiers."
        },
        {
          "type": "p",
          "text": "Ces cookies peuvent permettre à des tiers de collecter et d’utiliser vos données de navigation pour leurs propres finalités, conformément à leurs politiques de confidentialité et de cookies."
        },
        {
          "type": "p",
          "text": "Vous pouvez donner ou retirer votre consentement à tout moment, globalement ou par catégorie de cookies, lorsque ces options sont disponibles."
        },
        {
          "type": "p",
          "text": "Par défaut, les cookies non essentiels ne sont pas déposés sans votre consentement, lorsque la loi applicable l’exige."
        }
      ]
    },
    {
      "title": "2. À propos des cookies",
      "blocks": [
        {
          "type": "p",
          "text": "Nous utilisons différents types de cookies sur notre site pour assurer son bon fonctionnement, mesurer l’audience, améliorer les performances et renforcer l’interactivité de nos services."
        },
        {
          "type": "p",
          "text": "Les cookies peuvent nous aider à comprendre comment les visiteurs utilisent notre site, quelles pages sont consultées, comment les utilisateurs interagissent avec nos services et comment améliorer l’expérience."
        }
      ]
    },
    {
      "title": "3. Qu'est-ce qu'un cookie ?",
      "blocks": [
        {
          "type": "p",
          "text": "Un cookie est un petit fichier texte ou une information qui peut être stocké sur votre appareil lorsque vous visitez un site web."
        },
        {
          "type": "p",
          "text": "Les cookies permettent à un site de reconnaître votre navigateur ou appareil pendant votre visite ou lors d’une visite ultérieure. Ils peuvent servir notamment à :"
        },
        {
          "type": "ul",
          "items": [
            "Sécuriser le site",
            "Mémoriser les préférences",
            "Maintenir les informations de session",
            "Mesurer le trafic",
            "Améliorer les fonctionnalités",
            "Soutenir l’analyse et le marketing",
            "Activer du contenu ou des intégrations tiers"
          ]
        },
        {
          "type": "p",
          "text": "Les cookies peuvent être temporaires (supprimés à la fermeture du navigateur) ou persistants (conservés sur votre appareil pendant une durée définie)."
        }
      ]
    },
    {
      "title": "4. Types de cookies que nous utilisons",
      "blocks": [
        {
          "type": "p",
          "text": "DeMaxtore peut utiliser les types de cookies suivants :"
        }
      ]
    },
    {
      "title": "4.1 Cookies strictement nécessaires",
      "blocks": [
        {
          "type": "p",
          "text": "Ces cookies sont requis pour le bon fonctionnement du site. Ils permettent notamment :"
        },
        {
          "type": "ul",
          "items": [
            "La navigation",
            "La sécurité",
            "La gestion de session",
            "L’envoi de formulaires",
            "La gestion des préférences cookies",
            "L’accès aux zones sécurisées"
          ]
        },
        {
          "type": "p",
          "text": "Vous pouvez techniquement les bloquer dans votre navigateur, mais certaines parties du site pourraient ne plus fonctionner correctement."
        },
        {
          "type": "p",
          "text": "Ces cookies ne nécessitent pas de consentement lorsqu’ils sont strictement nécessaires au fonctionnement du site."
        }
      ]
    },
    {
      "title": "4.2 Cookies de performance et d’analyse",
      "blocks": [
        {
          "type": "p",
          "text": "Ces cookies nous aident à comprendre comment les visiteurs utilisent notre site. Ils permettent de mesurer et d’analyser :"
        },
        {
          "type": "ul",
          "items": [
            "Le trafic",
            "Les pages vues",
            "Le comportement des visiteurs",
            "Le temps passé sur les pages",
            "Les performances techniques",
            "L’interaction avec les fonctionnalités"
          ]
        },
        {
          "type": "p",
          "text": "Ces informations nous aident à améliorer la structure, le contenu, la vitesse et l’utilisabilité de www.demaxtore.com."
        },
        {
          "type": "p",
          "text": "Les cookies d’analyse ne sont utilisés que lorsque la loi l’autorise et, si nécessaire, avec votre consentement."
        }
      ]
    },
    {
      "title": "4.3 Cookies fonctionnels",
      "blocks": [
        {
          "type": "p",
          "text": "Les cookies fonctionnels permettent au site de mémoriser vos choix et d’offrir des fonctionnalités améliorées."
        },
        {
          "type": "p",
          "text": "Ils peuvent inclure :"
        },
        {
          "type": "ul",
          "items": [
            "Préférences de langue",
            "Préférences de région",
            "Informations de formulaire saisies précédemment",
            "Préférences d’interface",
            "Améliorations de l’expérience utilisateur"
          ]
        },
        {
          "type": "p",
          "text": "Si ces cookies sont désactivés, certaines fonctionnalités personnalisées peuvent ne pas fonctionner correctement."
        }
      ]
    },
    {
      "title": "4.4 Cookies marketing et publicitaires",
      "blocks": [
        {
          "type": "p",
          "text": "Les cookies marketing peuvent servir à proposer un contenu plus pertinent, mesurer les campagnes et évaluer l’efficacité publicitaire."
        },
        {
          "type": "p",
          "text": "Ils peuvent collecter des informations sur votre navigation sur notre site et, parfois, sur d’autres sites."
        },
        {
          "type": "p",
          "text": "Ils peuvent être déposés par DeMaxtore ou par des prestataires publicitaires et d’analyse tiers, selon les outils utilisés."
        },
        {
          "type": "p",
          "text": "Les cookies marketing ne sont utilisés qu’avec votre consentement lorsque la loi l’exige."
        }
      ]
    },
    {
      "title": "4.5 Cookies tiers",
      "blocks": [
        {
          "type": "p",
          "text": "Notre site peut s’appuyer sur des services tiers pour améliorer la fonctionnalité, l’interactivité, l’analyse, la communication ou le marketing."
        },
        {
          "type": "p",
          "text": "Ces services peuvent inclure notamment :"
        },
        {
          "type": "ul",
          "items": [
            "Outils d’analyse",
            "Plateformes publicitaires",
            "Vidéos ou médias intégrés",
            "Chat ou messagerie",
            "Intégrations de réseaux sociaux",
            "CRM, formulaires ou suivi",
            "Outils de sécurité et de performance"
          ]
        },
        {
          "type": "p",
          "text": "Ces tiers peuvent placer des cookies directement sur votre appareil lorsque vous utilisez leurs services sur notre site."
        },
        {
          "type": "p",
          "text": "Via ces cookies, les tiers peuvent collecter et utiliser vos données de navigation pour leurs propres finalités, notamment analyse, publicité ciblée, personnalisation ou amélioration de service."
        },
        {
          "type": "p",
          "text": "Pour plus d’informations, consultez les politiques de confidentialité et de cookies des prestataires concernés."
        }
      ]
    },
    {
      "title": "5. Cookies pour le fonctionnement du site",
      "blocks": [
        {
          "type": "p",
          "text": "Certains cookies sont nécessaires aux fonctions clés du site. Ils contribuent notamment à ce que :"
        },
        {
          "type": "ul",
          "items": [
            "Le site se charge correctement",
            "Les formulaires de contact fonctionnent",
            "Les fonctions de sécurité opèrent",
            "Les sessions utilisateur soient maintenues",
            "Les choix cookies soient mémorisés",
            "Les fonctionnalités restent stables"
          ]
        },
        {
          "type": "p",
          "text": "Sans ces cookies, certaines parties du site peuvent ne pas fonctionner comme prévu."
        }
      ]
    },
    {
      "title": "6. Cookies pour améliorer l’interactivité",
      "blocks": [
        {
          "type": "p",
          "text": "DeMaxtore peut utiliser des outils tiers pour améliorer l’interactivité du site, notamment :"
        },
        {
          "type": "ul",
          "items": [
            "Vidéos intégrées",
            "Formulaires interactifs",
            "Chat en direct",
            "Partage social",
            "Visualisation de contenu externe",
            "Tableaux de bord analytiques",
            "Suivi de campagnes marketing"
          ]
        },
        {
          "type": "p",
          "text": "Ces fonctionnalités peuvent utiliser des cookies tiers déposés directement par les prestataires."
        },
        {
          "type": "p",
          "text": "Sans consentement, certains contenus interactifs ou fonctionnalités tierces peuvent être indisponibles."
        }
      ]
    },
    {
      "title": "7. Consentement aux cookies",
      "blocks": [
        {
          "type": "p",
          "text": "Lorsque la loi l’exige, nous demandons votre consentement avant de placer des cookies non essentiels sur votre appareil."
        },
        {
          "type": "p",
          "text": "Vous pouvez :"
        },
        {
          "type": "ul",
          "items": [
            "Accepter tous les cookies",
            "Refuser les cookies non essentiels",
            "Gérer vos préférences par catégorie",
            "Retirer votre consentement à tout moment"
          ]
        },
        {
          "type": "p",
          "text": "Si vous retirez votre consentement, des cookies déjà placés peuvent rester sur votre appareil jusqu’à suppression via le navigateur ou jusqu’à expiration."
        }
      ]
    },
    {
      "title": "8. Comment gérer les cookies",
      "blocks": [
        {
          "type": "p",
          "text": "Vous pouvez gérer les cookies de deux manières :"
        },
        {
          "type": "p",
          "text": "Via notre outil de préférences cookies"
        },
        {
          "type": "p",
          "text": "Lorsqu’il est disponible, vous pouvez gérer vos préférences via la bannière cookies ou le panneau de paramètres sur notre site."
        },
        {
          "type": "p",
          "text": "Via les paramètres de votre navigateur"
        },
        {
          "type": "p",
          "text": "La plupart des navigateurs permettent de :"
        },
        {
          "type": "ul",
          "items": [
            "Voir les cookies stockés",
            "Supprimer les cookies",
            "Bloquer les cookies",
            "Définir des préférences par site",
            "Recevoir un avertissement avant stockage"
          ]
        },
        {
          "type": "p",
          "text": "Bloquer tous les cookies peut affecter le fonctionnement et les performances de notre site."
        }
      ]
    },
    {
      "title": "9. Responsabilité des tiers",
      "blocks": [
        {
          "type": "p",
          "text": "Les cookies tiers sont contrôlés par les prestataires concernés. DeMaxtore ne contrôle pas entièrement l’utilisation des cookies par les tiers ni le traitement des données collectées via leurs technologies."
        },
        {
          "type": "p",
          "text": "Nous vous recommandons de consulter les politiques de confidentialité et de cookies des services tiers avec lesquels vous interagissez via notre site."
        }
      ]
    },
    {
      "title": "10. Modifications de la présente politique",
      "blocks": [
        {
          "type": "p",
          "text": "Nous pouvons mettre à jour cette politique des cookies pour refléter des changements sur notre site, l’usage des cookies, les outils tiers, les exigences légales ou nos opérations."
        },
        {
          "type": "p",
          "text": "Toute mise à jour sera publiée sur cette page avec la date « Dernière mise à jour » révisée."
        }
      ]
    },
    {
      "title": "11. Contact",
      "blocks": [
        {
          "type": "p",
          "text": "Pour toute question concernant cette politique des cookies ou notre utilisation des cookies, contactez-nous :"
        },
        {
          "type": "ul",
          "items": [
            "Demakstore Gıda İhracat San. ve Tic. Ltd. Şti.",
            "Marque exploitée : DeMaxtore",
            "Site web : www.demaxtore.com",
            "E-mail : support@demaxtore.com",
            "E-mail alternatif : demaxtore@demaxtore.com"
          ]
        }
      ]
    }
  ]
};
